import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {SharedDataService} from '../../provider/shared-data/shared-data.service';
import {StorageService} from '../../provider/storage/storage.service';
import {APP_CONDITION_ITEMS, APP_ICON_PATH, APP_ROUTES} from '../../../environments/environment';
import {ConfigurationObject, SearchObjectsExObj, SearchQueryParams} from '../../interfaces/interfaces.regisafe';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {AppConfig} from '../../app.config';

@Component({
	selector: 'app-regisafe-footer',
	templateUrl: './regisafe-footer.component.html',
	styleUrls: ['./regisafe-footer.component.scss'],
})
export class RegisafeFooterComponent implements OnInit, OnChanges {

	@Input() type = 'default';
	@Input() substrukturen = [];
	@Input() searchInOtherStructures = false;
	@Input() strukturenMitFavoriten = [];

	@Output() selectedSubstructure: EventEmitter<any> = new EventEmitter<any>();
	@Output() metadataVisibility: EventEmitter<any> = new EventEmitter<any>();

	public configuration: ConfigurationObject;

	appIconPath = APP_ICON_PATH;

	// TAB's (Orgastrukturen)
	defaultOragStructrure = 'Aktenplanverwaltung';
	currentSegment: string;
	currentSubSegment: string;
	shared: any;
	orgaStructureTabs = [];
	tempBody: SearchObjectsExObj = {};

	constructor(public sharedService: SharedDataService,
				private storageService: StorageService,
				private router: Router,
				private activatedRoute: ActivatedRoute,
				public appConfig: AppConfig) {
		this.configuration = this.appConfig.getConfig();
	}

	ngOnInit() {
		this.shared = this.sharedService.getRegisafeGlobalData();
		this.currentSegment = this.shared.orgastruktur;
		this.getOrgaStructs();
		// this.emitSubStructures(this.substrukturen[0]);
		this.currentSubSegment = this.substrukturen[0];

		if (this.substrukturen.length < 1) {
			this.substrukturen[0] = 'meta';
		}

		try {
			this.tempBody.osId = this.activatedRoute.snapshot.queryParamMap.get('osId');
			this.tempBody.searchText = this.activatedRoute.snapshot.queryParamMap.get('searchText');
			this.tempBody.searchFields = this.activatedRoute.snapshot.queryParamMap.get('searchFields');
			this.tempBody.apiID = this.configuration.iqapiAppId;
			this.tempBody.sessionToken = this.storageService.getToken();
		} catch (e) {
			console.log('tempBody error: ', e);
		}
	}

	ngOnChanges(changes: SimpleChanges) {

		if (changes.hasOwnProperty('substrukturen')) {
			this.emitSubStructures(this.substrukturen[0]);
		}

		if (changes.hasOwnProperty('strukturenMitFavoriten')) {
			this.strukturenMitFavoriten = changes.strukturenMitFavoriten.currentValue;
		}
	}

	orgaStructureChange(event) {
		this.currentSegment = event.target.value;
		this.tempBody.osId = event.target.value;

		if (this.searchInOtherStructures) {
			const searchQueryParams: SearchQueryParams = {
				osId: event.target.value,
				searchText: this.tempBody.searchText,
				searchFields: this.tempBody.searchFields,
			};

			const navigationExtras: NavigationExtras = {
				queryParams: searchQueryParams
			};

			const rand = Math.floor(Math.random() * 9999) + 1000;
			this.router.navigate([APP_ROUTES.suchergebnisse, rand], navigationExtras);
		}
	}

	subStructureChange(event) {
		this.currentSubSegment = event.target.value;
	}

	getSegementData(event) {
		this.sharedService.setRegisafeGlobalData({
			iconname: event.target.getAttribute('data-icon'),
			iconcolor: event.target.getAttribute('data-color'),
			title: event.target.getAttribute('data-title'),
			orgastruktur: event.target.value,
		});
	}

	/**
	 * getOrgaStructs()
	 *
	 * Die Methode holt alle OrgaStrukturen aus den Conditions und übergibt
	 * diese in Form eines Array's sortiert nach 'osSortIndex' an das Template;
	 */
	async getOrgaStructs() {
		const orgaStructs = await this.storageService.getConditions(APP_CONDITION_ITEMS.orgaStructs);
		const tempStructs = [];
		Object.keys(orgaStructs).forEach((structure, index) => {
			const structureObj = {
				value: orgaStructs[structure].osId, // osId
				title: orgaStructs[structure].osStructName, // osStructName
				index: orgaStructs[structure].osSortIndex, // osStructName
			};
			tempStructs.push(structureObj);
		});

		const sortedTempStructs = tempStructs.sort((a, b) => {
			if (a.index < b.index) {
				return -1;
			}
			if (a.index > b.index) {
				return 1;
			}
			return 0;
		});
		this.orgaStructureTabs = sortedTempStructs;
	}

	emitSubStructures(structure: string, clickEvent: boolean = false) {
		this.selectedSubstructure.emit(structure);
		if (clickEvent) {
			this.metadataVisibility.emit(false);
		}
	}

	showMetadata() {
		this.metadataVisibility.emit(true);
	}
}
